import dayjs from "dayjs";
import {
    ListDetailItemList,
    ListDetailViewSectionContent,
    ListDetailViewSectionHeader,
    ListDetailViewSectionLayout,
    ListViewItem,
} from "../../components/ListDetailView";
import { formatCurrency } from "../../utils/numbers";
import { useUserInfo } from "../../utils/security";
import { AddOutlined, EventRepeatOutlined, FileDownloadOutlined } from "@mui/icons-material";
import { FinancialSimpleFilter } from "./FinancialSimpleFilter";
import { Box } from "@mui/material";
import { FinancialAdvancedFilter } from "./FInancialAdvancedFilter";
import { FinancialsOverviewContent } from "./FinancialsOverview";

const TransactionListItem = ({ data, _onClick, ...props }) => {
    const { userInfo } = useUserInfo();
    return (
        <ListViewItem
            {...props}
            mainText={data.name}
            secondaryText={[data.transactionTypeName, data.idNumber, data.cptyName]}
            mainValue={formatCurrency(
                data.amount * (data.direction === "EXPENDITURE" ? -1 : 1),
                "CZK",
                userInfo.currencies,
                2,
                userInfo.decimalDelimiter,
                userInfo.thousandDelimiter
            )}
            secondaryValue={dayjs(data.date).format(userInfo.dateFormat)}
        />
    );
};

export const FinancialsList = ({
    overviewState,
    compact,
    loading,
    onAddTransaction,
    data,
    selectItem,
    detailId,
    setFilter,
    filter,
    filterVisible,
    setFilterVisible,
    onShowRecurringDialog,
}) => {
    const { userInfo } = useUserInfo();

    return (
        <ListDetailViewSectionLayout loading={loading}>
            <ListDetailViewSectionHeader
                title="Finance"
                role="list"
                loading={loading}
                compact={compact}
                actions={[
                    { title: "Export", icon: <FileDownloadOutlined /> },
                    {
                        title: "Přidat opakovanou transakci",
                        icon: <EventRepeatOutlined />,
                        onClick: onShowRecurringDialog,
                    },
                    {
                        title: "Přidat transakci...",
                        icon: <AddOutlined />,
                        items: (userInfo?.transactionTypes || []).map((transactionType) => ({
                            title: transactionType.name,
                            icon: <AddOutlined />,
                            onClick: () => onAddTransaction?.(transactionType),
                        })),
                    },
                ]}>
                <FinancialSimpleFilter />
            </ListDetailViewSectionHeader>
            <ListDetailViewSectionContent>
                <Box px={2}>
                    <FinancialAdvancedFilter />
                    {compact === true && (
                        <FinancialsOverviewContent
                            data={overviewState?.data}
                            loading={overviewState?.loading}
                        />
                    )}
                </Box>
                <ListDetailItemList
                    data={data}
                    loading={loading}
                    renderItem={TransactionListItem}
                    compact={compact}
                    detailId={detailId}
                    selectItem={selectItem}
                />
            </ListDetailViewSectionContent>
        </ListDetailViewSectionLayout>
    );
};
